import styles from '../../docxTemplateWidget.module.css';

interface Props{
    docx?: boolean;
}
export default function NoteSection({docx}: Props) {
    return (
        <div className={styles.noteSection}>
            {docx && <p className={styles.noteSectionText}>Here you can customize what your template will be populated with. Check out the <a href="https://docs.pentra.ai/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--light-blue-icon)', textDecoration: 'underline' }}>documentation</a> for more information for the docx template.</p>}
            {!docx && <p className={styles.noteSectionText}>You can also upload a custom docx template. Check out the <a href="https://docs.pentra.ai/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--light-blue-icon)', textDecoration: 'underline' }}>documentation</a> for more information.</p>}
        </div>
    );
}
